const PropTypes = require('prop-types');
// @vendors
const React = require('react');
const { connect } = require('react-redux');
const noop = require('lodash/utility/noop');

// @commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

class BrokerMIFIDUSPersonButton extends React.Component {
    constructor(props) {
        super(props);

        this.state = { mustMountModal: false };

        this.handleClick = this.handleClick.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleContinue = this.handleContinue.bind(this);
    }

    componentWillReceiveProps(newProps) {
        if (newProps.immBrokerMiFIDUSPerson.get('error')) {
            this.setState({ mustMountModal: false });
        }
    }

    handleCancel() {
        this.setState({ mustMountModal: false });
        this.props.onCancel();
    }

    handleClick() {
        const { immBrokerMiFIDUSPerson } = this.props;

        const noInstancesRunning = (
            !immBrokerMiFIDUSPerson.get('isFetching') &&
            !immBrokerMiFIDUSPerson.get('isFetched')
        );

        this.setState({ mustMountModal: noInstancesRunning });
    }

    handleContinue() {
        this.setState({ mustMountModal: false });
        this.props.onClick();
    }

    render() {
        const loading = (
            this.props.immBrokerMiFIDUSPerson.get('isFetching') &&
            this.state.mustMountModal
        );


        let button;
        let innerTooltipButton;

        if (this.props.disabled && this.props.disabledTooltipText) {
            innerTooltipButton = (
                <span>
                    <OKButton
                        {...this.props}
                        loading={loading}
                        onClick={this.handleContinue}
                    >
                        {this.props.children}
                    </OKButton>
                </span>
            );

            button = (
                <OKTooltip
                    content={this.props.disabledTooltipText}
                    offset={[0, -25]}
                    target={innerTooltipButton}
                />
            )
        } else {
            button = (
                <OKButton
                    {...this.props}
                    loading={loading}
                    onClick={this.handleContinue}
                >
                    {this.props.children}
                </OKButton>
            );
        }

        return button;
    }
}

BrokerMIFIDUSPersonButton.propTypes = {
    immBrokerMiFIDUSPerson: PropTypes.object.isRequired,
    onClick: PropTypes.func.isRequired,
    isinId: PropTypes.string.isRequired,
    marketId: PropTypes.string,
    onCancel: PropTypes.func,
    children: PropTypes.any,
    disabled: PropTypes.bool,
    disabledTooltipText: PropTypes.string
};

BrokerMIFIDUSPersonButton.defaultProps = {
    onCancel: noop,
    disabledTooltipText: '',
    disabled: false
};

module.exports = connect(
    (state) => ({ immBrokerMiFIDUSPerson: state.brokerMiFIDUSPerson }),
    {}
)(BrokerMIFIDUSPersonButton);
